import { useLayoutEffect } from 'react'

/** The detail owns its position; browser restoration can run after async rows mount. */
export function useHandheldDetailScroll(learnerId: number, params: URLSearchParams) {
  const target = params.has('unitAssessmentId') ? ['unit', params.get('unitAssessmentId')]
    : params.has('testKind') ? ['test', params.get('testKind'), params.get('scopeContentId'), params.get('chapterOrdinal')]
      : ['lesson', params.get('lessonId'), params.get('attempt'), params.get('review'), params.get('section')]
  const targetKey = JSON.stringify([learnerId, ...target])

  useLayoutEffect(() => {
    const previousRestoration = window.history.scrollRestoration
    const root = document.documentElement
    const previousAnchor = root.style.overflowAnchor
    window.history.scrollRestoration = 'manual'
    // New query results and images must not anchor the viewport to a later question.
    root.style.overflowAnchor = 'none'
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    }
    window.addEventListener('pageshow', onPageShow)
    return () => {
      window.history.scrollRestoration = previousRestoration
      root.style.overflowAnchor = previousAnchor
      window.removeEventListener('pageshow', onPageShow)
    }
  }, [])

  useLayoutEffect(() => {
    const reset = () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    reset()
    const frame = requestAnimationFrame(reset)
    return () => cancelAnimationFrame(frame)
  }, [targetKey])
}
